import {Box, Skeleton, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from "@mui/material";
import {CampaignPhoneNumberRowNew} from "./CampaignPhoneNumberRowNew";

const headerCellSx = {
  fontWeight: 700, fontSize: 11, py: 1, px: 1.5,
  color: "#8A8AA0", textTransform: "uppercase", letterSpacing: "0.06em",
  bgcolor: "#FAFAFD", borderBottom: "1px solid #ECECF3", whiteSpace: "nowrap",
};

const columns = ["Phone number", "Status", "Attempts", "Last queued", "Last called", "Last conversation", "Updated"];

const SkeletonRow = () => (
  <TableRow>
    {columns.map(column => (
      <TableCell key={column} sx={{border: "none", py: 1.25}}><Skeleton height={16} sx={{borderRadius: "6px"}}/></TableCell>
    ))}
    <TableCell sx={{border: "none"}}/>
  </TableRow>
);

export const CampaignPhoneNumbersTableNew = ({
  rows, total, loading, page, rowsPerPage, onPageChange, onRowsPerPageChange,
  maxAttempts, projectId, callingId, onCall, onShowAttempts, onDelete
}) => {
  return (
    <Box sx={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", bgcolor: "#fff", border: "1px solid #ECECF3", borderRadius: "16px"}}>
      <Box sx={{flex: 1, overflowY: "auto"}}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {columns.map(column => <TableCell key={column} sx={headerCellSx}>{column}</TableCell>)}
              <TableCell padding="checkbox" sx={headerCellSx}/>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && rows.length === 0
              ? Array.from({length: 5}).map((_, index) => <SkeletonRow key={index}/>)
              : rows.map(row => (
                  <CampaignPhoneNumberRowNew
                    key={row.id}
                    row={row}
                    maxAttempts={maxAttempts}
                    projectId={projectId}
                    calling={callingId === row.id}
                    onCall={onCall}
                    onShowAttempts={onShowAttempts}
                    onDelete={onDelete}
                  />
                ))
            }
            {!loading && rows.length === 0 &&
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center" sx={{py: 6, color: "#8A8AA0", border: "none"}}>
                  No phone numbers
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </Box>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(e, newPage) => onPageChange(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
        rowsPerPageOptions={[20, 50, 100]}
        sx={{color: "#6B6B80"}}
      />
    </Box>
  )
}
